import React from 'react'
import * as Errors from '@morningtrain/react-errors'
import AdminTopNavigation from 'widgets/navigation/AdminTopNavigation'
import ImpersonationBar from 'widgets/auth/ImpersonationBar'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'
import {Env} from "@morningtrain/helpers";

export default function TemplateContent ({
  children,
  withGlobalDepartmentFilter = true,
  withoutAllDepartments = false
}) {
  const isStocktake = Env.get('page.component') === "app.Inventory.Stocktake";
  return (
    <div className='h-screen overflow-hidden overflow-y-auto flex flex-col flex-grow pb-12 xl:pb-0'>
      <ImpersonationBar />
      <WhenDeviceNotAuthorized>
        <div className={`px-8 ${isStocktake ? `` : `pt-4 xl:pt-6`}`}>
          <AdminTopNavigation withGlobalDepartmentFilter={withGlobalDepartmentFilter} withoutAllDepartments={withoutAllDepartments} />
        </div>
      </WhenDeviceNotAuthorized>
      <div className={`${isStocktake ? 'h-full' : 'p-8'}`}>
        <Errors.Boundary>
          {children}
        </Errors.Boundary>
      </div>
    </div>
  )
}
